import React, { useState, useEffect } from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  Typography,
} from "@material-ui/core";
import sigmaredLogo from "../../assets/sigmared-logo-svg.svg";

import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import LogoutIcon from "./logout.png";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AssistantOutlinedIcon from "@material-ui/icons/AssistantOutlined";
import MultilineChartOutlinedIcon from "@material-ui/icons/MultilineChartOutlined";
import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";
// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { signOut, useUserDispatch } from "../../context/UserContext";
import SidebarIcon from "./components/SidebarIcon";

const structure = [
  // { id: 11, type: "title", label: "Dashboard" },
  // { id: 10, type: "divider" },

  {
    id: 0,
    label: "Model Inventory",
    link: "/app/dashboard",
    icon: <AssessmentOutlinedIcon />,
  },

  // { id: 18, label: "Payment", link: "/app/sitemanagement/payments", icon: <Payment /> },

  // { id: 1111, type: "title", label: "User Management" },
  // { id: 102323, type: "divider" },
  // { id: 183232, label: "Users", link: "/app/users", icon: <Payment /> },
  // { id: 183234, label: "Project", link: "/app/inventory", icon: <HomeIcon /> },
  // { id: 183238, label: "Compliance", link: "/app/compliance2", icon: <FolderShared /> },

  { id: 1111, type: "title", label: "Modules" },
  // { id: 102323, type: "divider" },
  {
    id: 183235,
    label: "ML Fairness",
    link: "",
    icon: <VerifiedUserOutlinedIcon />,
    children: [
      { label: "Summary", link: "/app/biasSummary" },
      { label: "Bias", link: "/app/fairness" },
      { label: "Proxy Bias", link: "/app/aiproxy" },
      { label: "Intersectional", link: "/app/aievalation" },
    ],
  },
  {
    id: 213,
    label: "ML Explainability",
    link: "/app/Explainability",
    icon: <AssistantOutlinedIcon />,
  },
  {
    id: 1123,
    label: "ML Monitoring",
    link: "",
    icon: <MultilineChartOutlinedIcon />,
    children: [
      { label: "Monitoring", link: "/app/Monitor" },
      { label: "Alert", link: "/app/Mlalert" },
    ],
  },
  {
    id: 12121,
    label: "AI Compliance",
    link: "/app/compliance",
    icon: <LanguageOutlinedIcon />,
  },
];

function Sidebar({ location, history }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();
  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      style={{ minHeight: "100vh" }}
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />

      <div className={classes.logoContainer}>
        {isSidebarOpened && (
          <img src={sigmaredLogo} alt="Logo" className={classes.logoImage} />
        )}
        <div className={classes.mobileBackButton}>
          <IconButton
            onClick={() => toggleSidebar(layoutDispatch)}
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          >
            <SidebarIcon
              style={{
                color: "#667085",
              }}
            />
          </IconButton>
        </div>
      </div>

      <List
        className={classes.sidebarList}
        style={{ "background-color": "#fff" }}
      >
        {structure.map((link) => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>

      <div className={classes.logoutBox}>
        <Divider className={classes.divider} />
        <div className={isSidebarOpened?classes.logoutContent:classes.logoutContent2}>
          {isSidebarOpened && (
            <div className={classes.logoutTextBox}>
              <Typography className={classes.titleText}>Demo User 1</Typography>
              <Typography className={classes.text}>
                demo@sigmared.ai
              </Typography>
            </div>
          )}
          <IconButton
            onClick={() => signOut(userDispatch, history)}
            className={classes.text}
          >
            <img src={LogoutIcon} alt="logout" width={"18px"} />
          </IconButton>
        </div>
      </div>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
